import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Toast } from './toast.model';
import { ToastService } from './toast.service';
//import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'q-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})

export class ToastComponent implements OnInit, OnDestroy {

  // #region VARIABLES GLOBALES
  subToasts: Subscription;
  toasts: Toast[];
  // #endregion

  // #region CONSTRUCTEUR
  constructor(
    private toast: ToastService //,
    //private sanitizer: DomSanitizer
  ) {}
  // #endregion

  // #region CYCLE DE VIE
  ngOnInit(): void {
    this.subToasts = this.toast.getToasts().subscribe((toasts: Toast[]) => {
      this.toasts = toasts;
    });
  }

  ngOnDestroy(): void {
    this.subToasts.unsubscribe();
  }
  // #endregion

  // #region FONCTIONS PUBLIQUES
  public removeToast(toast: Toast): void {
    this.toast.removeToast(toast);
  }

  //public getSafeHtml(toastElement: Toast): SafeHtml {
  //  return this.sanitizer.bypassSecurityTrustHtml(toastElement.innerContent);
  //}
  // #endregion
}
